import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../css/paysuccess.css";
import { SITE_CONFIG } from "../config/siteConfig";

const states = {
  success: {
    symbol: "✓",
    title: "Checkout return received",
    message: "Your browser returned through the success link. This is not independent confirmation that funds have settled. The merchant must verify the hosted payment record before fulfilment.",
  },
  cancel: {
    symbol: "↩",
    title: "Payment was cancelled",
    message: "The hosted checkout did not complete through the success path. Your cart remains available, so you can review it and try again when ready.",
  },
  failed: {
    symbol: "!",
    title: "Payment session could not be created",
    message: `No paid order should be assumed. Return to the cart or email ${SITE_CONFIG.supportEmail} if the issue repeats. Do not send card details by email.`,
  },
};

const PaymentResult = () => {
  const [searchParams] = useSearchParams();
  const state = searchParams.get("state");
  const content = states[state] || states.failed;

  return (
    <main className={`successDiv payment-result payment-result--${states[state] ? state : "failed"}`}>
      <div className="success-container">
        <div className="modal-content">
          <div className="checkmark-circle" aria-hidden="true"><span>{content.symbol}</span></div>
          <h1>{content.title}</h1>
          <p>{content.message}</p>
          <div className="payment-result__actions">
            <Link to="/cartpage">View cart</Link>
            <Link to="/shop">Continue shopping</Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PaymentResult;
